"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dPlotRange = void 0;
const rc_js_util_1 = require("rc-js-util");
const cartesian2d_float_precision_range_bounder_1 = require("../../eventing/cartesian2d-float-precision-range-bounder");
/**
 * @public
 * {@inheritDoc ICartesian2dPlotRange}
 */
class Cartesian2dPlotRange {
    constructor(maxBounds, dataRange, maxZoom, interactionBounder, userTransform) {
        this.isDirty = true;
        this.userTransform = userTransform;
        this.interactionBounder = interactionBounder;
        this.maxBounds = maxBounds;
        this.dataRange = dataRange;
        this.minRange = dataRange
            .slice()
            .fill(0);
        this.updateBounds(maxBounds, maxZoom);
        this.transformedDataRange = this.userTransform.forwardTransformRange(dataRange);
    }
    static createOneF32(options) {
        return new Cartesian2dPlotRange(options.maxBounds, options.dataRange, options.maxZoom, new cartesian2d_float_precision_range_bounder_1.Cartesian2dFloatPrecisionRangeBounder(rc_js_util_1._F32, 0.1), options.userTransform);
    }
    static createOneF64(options) {
        return new Cartesian2dPlotRange(options.maxBounds, options.dataRange, options.maxZoom, new cartesian2d_float_precision_range_bounder_1.Cartesian2dFloatPrecisionRangeBounder(rc_js_util_1._F64, 0.1), options.userTransform);
    }
    updateDataRange(unclampedDataRange) {
        this.dataRange.set(unclampedDataRange);
        this.isDirty = true;
    }
    updateBounds(bounds, maxZoom) {
        maxZoom = rc_js_util_1._Math.bound(maxZoom, 1, this.interactionBounder.maxZoom);
        this.maxBounds.set(bounds);
        this.maxBounds.bound(this.interactionBounder.maxBounds);
        this.minRange.update(0, bounds.getXRange() / maxZoom, 0, bounds.getYRange() / maxZoom);
        this.isDirty = true;
    }
    updateUserTransform(userTransform) {
        this.userTransform = userTransform;
        this.transformedDataRange = this.userTransform.forwardTransformRange(this.dataRange);
    }
    update(canvasDims) {
        if (!this.isDirty) {
            return;
        }
        this.dataRange.ensureMinRange(this.minRange.getXMax(), this.minRange.getYRange());
        this.interactionBounder.boundRange(this.dataRange, canvasDims.pixelDims, this.maxBounds);
        this.userTransform.forwardTransformRange(this.dataRange, this.transformedDataRange);
    }
}
exports.Cartesian2dPlotRange = Cartesian2dPlotRange;
//# sourceMappingURL=cartesian2d-plot-range.js.map